module.exports = __webpack_public_path__ + "_assets/img/record.33714444.svg";